if (!customElements.get('hero-slider')) {
    class HeroSlider extends HTMLElement {
        constructor() {
            super();
            this.arrowShape = this.getAttribute('data-arrow-shape');
            this.handleKeyDown = this.handleKeyDown.bind(this); // Maintain the context of 'this' for the event listener
            this.slider = null;
        }

        connectedCallback() {
            if (this.getAttribute('data-disabled')) return;
            if (!window.Flickity) return;

            this.slider = new window.Flickity(this, {
                wrapAround: true,
                imagesLoaded: true,
                pageDots: false
            });

            this.slider.on('settle', (event, cellElement) => {
                this.slider.resize();
            });

            const previous = this.querySelector('.previous');
            const next = this.querySelector('.next');

            if (!previous || !next) return;

            previous.innerHTML = this.arrowShape;
            next.innerHTML = this.arrowShape;

            /*previous.addEventListener('click', () => {
                this.slider.previous();
            });

            next.addEventListener('click', () => {
                this.slider.next();
            });*/ 

            var cellElement = document.querySelectorAll('.affliate_slider');
            var heroSlider = document.querySelector('hero-slider');

            // Add keyboard navigation
            //document.addEventListener('keydown', this.handleKeyDown); // Use bound function here
            // Event listeners only for this carousel
            this.slider.element.addEventListener('keydown', this.handleKeyDown);

            var flicktySlider = this.slider;
            var nowDate = new Date();
            var endDate = new Date();

            if (customer) {
                var refrel = '';
                poicodeDetails.forEach((data) => {
                    (data.poicode === poicode ?
                        (
                            refrel = data.domain,
                            endDate = new Date(data.endDate)
                        )
                        :
                        ''
                    )
                })

                var diff = endDate.getTime() - nowDate.getTime();
                var daydiff = diff / (1000 * 60 * 60 * 24);

                cellElement.forEach((elm) => {
                    var domain = elm.dataset.domain;
                    if (refrel == null || refrel == undefined) {
                        flicktySlider.remove(elm);
                    } else if (refrel.indexOf(domain) == -1) {
                        flicktySlider.remove(elm);
                    } else if (daydiff <= 0) {
                        flicktySlider.remove(elm);
                    }
                })
                heroSlider.style.visibility = "visible";
                return;
            }


            var refrel = document.referrer;
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.get('domain') != null) {
                refrel = urlParams.get('domain')
            }
            if (refrel == '' || refrel == null) {
                refrel = sessionStorage.getItem('affiliate');
            } else if (refrel.indexOf('korres.com') > -1) {
                refrel = sessionStorage.getItem('affiliate');
            }

            var daydiff = 0;

            if (refrel != '' && refrel != null) {

                poicodeDetails.forEach((data) => {
                    (refrel.indexOf(data.domain) > -1 ?
                        (
                            refrel = data.domain,
                            endDate = new Date(data.endDate)
                        )
                        :
                        ''
                    )
                })

                var diff = endDate.getTime() - nowDate.getTime();
                var daydiff = diff / (1000 * 60 * 60 * 24);
            }

            cellElement.forEach((elm) => {
                var domain = elm.dataset.domain;
                if (refrel == null || refrel == undefined) {
                    flicktySlider.remove(elm);
                } else if (refrel.indexOf(domain) == -1) {
                    flicktySlider.remove(elm);
                } else if (daydiff < 0) {
                    flicktySlider.remove(elm);
                } else {
                    sessionStorage.setItem('affiliate', domain)
                }
            })
            heroSlider.style.visibility = "visible";

            
        }

        handleKeyDown(event) {
            // If tab key is pressed
            if (event.key === 'Tab') {
                // Focus on the Flickity container
                this.slider.element.focus();
            }

            // If left arrow key is pressed
            if (event.key === 'ArrowLeft' && document.activeElement.closest('.hero-slider-home')) {
                // Go to previous slide
                this.slider.previous();
            }

            // If right arrow key is pressed
            if (event.key === 'ArrowRight' && document.activeElement.closest('.hero-slider-home')) {
                // Go to next slide
                this.slider.next();
            }
        } 
    }

    customElements.define('hero-slider', HeroSlider);
}
